import { apiClient, postBlobApiV2 } from '../util/http';

const serializeParams = (params) => {
  const { startDate, endDate, companyIds } = params;

  return {
    ...params,
    startDate: startDate && startDate.format('YYYY-MM-DD'),
    endDate: endDate && endDate.format('YYYY-MM-DD'),
    companyIds: companyIds && companyIds.length > 0 ? companyIds : undefined,
  };
};

export const sendContractToCooperator = async (companyId, data) =>
  apiClient.post(`/cooperator/company/${companyId}/send/contract`, data);

export const downloadDismissedCooperatorsReport = (params) =>
  postBlobApiV2('/cooperator-report/dismissed-removed', serializeParams(params));
